"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.articles = void 0;
exports.articles = [{
        title: "What Is the NYC Housing Lottery? A 2025 Guide to Affordable Housing",
        published: "2025-05-29",
        shortDescription: "In this article you’ll learn how the lottery works — and the smartest ways to boost your odds of winning.",
        description: "The NYC Housing Lottery is your chance to secure a brand‑new, rent‑stabilized apartment in New York City. In this article you’ll learn how the lottery works — and the smartest ways to boost your odds of winning.",
        thumbnail: "https://cdn-images-1.medium.com/max/1600/0*kd3gJlu8Os0vy4dj.png",
        article: "/assets/articles/what-is.md",
        slug: "what-is-housing-lottery"
    }, {
        title: "What Is NYC Housing Connect? A 2025 Guide to Applying for Affordable Housing",
        published: "2025-06-02",
        shortDescription: "Housing Connect is the NYC’s official online portal for applying to affordable housing lotteries. In this guide you’ll learn how Housing Connect works & some handy tips to make the most out of it.",
        description: "Housing Connect is the NYC’s official online portal for applying to affordable housing lotteries. In this guide you’ll learn how Housing Connect works & some handy tips to make the most out of it.",
        thumbnail: "https://cdn-images-1.medium.com/max/1600/0*bQvS69R4-nR4_nDV.png",
        article: "/assets/articles/housing-connect.md",
        slug: "what-is-housing-connect"
    }, {
        title: "How to Apply for the NYC Housing Lottery in 2025",
        published: "2025-01-27",
        shortDescription: "Step-by-step guide to applying for the NYC Housing Lottery in 2025, eligibility tips, and a free tool that files every application for you.",
        description: "Step-by-step guide to applying for the NYC Housing Lottery in 2025, eligibility tips, and a free tool that files every application for you.",
        thumbnail: "https://miro.medium.com/v2/resize:fit:1400/1*u3UknMiYLSmdsxK18zvqIw.png",
        article: "/assets/articles/applying-in-2025.md",
        slug: "applying-in-2025"
    }, {
        title: "Top 5 NYC Housing Lottery Mistakes to Avoid",
        published: "2024-02-12",
        shortDescription: "Avoid common mistakes that can disqualify you from the NYC Housing Lottery and ruin your chance at affordable housing.",
        description: "Avoid the five disqualifying mistakes most NYC Housing Lottery applicants make and boost your chances, plus a tool that files every application for you",
        thumbnail: "https://miro.medium.com/v2/resize:fit:1400/1*FFZ3OezaZ5BZgqyY9K0V_Q.png",
        article: "/assets/articles/5-mistakes.md",
        slug: "top-5-mistakes"
    }, {
        title: "5 NYC Housing Lottery Myths Debunked",
        published: "2024-03-12",
        shortDescription: "Discover the truth behind 5 common New York City’s affordable housing lottery myths.",
        description: "Think the lottery is only for the very poor or that applying early helps? Bust the top myths and learn how Homey files every application for you.",
        thumbnail: "https://miro.medium.com/v2/resize:fit:1400/1*QQcGb_skiXmYZMv9OIFbbw.png",
        article: "/assets/articles/5-myths.md",
        slug: "5-myths"
    }, {
        title: "NYC Housing Lottery & Disability: Set-Asides + Accommodations",
        published: "2024-03-28",
        shortDescription: "If you’re a New Yorker living with a disability and searching for affordable housing, the NYC Housing Lottery can offer real opportunities — but the process can be confusing. A straightforward guide to disability set-aside units and reasonable accommodation.",
        description: "Qualify for disability set-aside units and request reasonable accommodations—here’s exactly how, plus a tool that files every application for you",
        thumbnail: "/assets/articles/disability-thumbnail.webp",
        article: "/assets/articles/with-disability.md",
        slug: "with-disability"
    }, {
        title: "NYC Housing Lottery Income Limits 2025",
        published: "2024-04-03",
        shortDescription: "Not sure if your income qualifies for affordable housing? Here’s a quick guide to 2025 NYC income limits.",
        description: "Check the 2025 NYC Housing Lottery income bands and instantly see which lotteries match your household, plus a tool that auto-files every application for you.",
        thumbnail: "https://cdn-images-1.medium.com/max/1600/1*aP34Il36XcEZ4JoZY005pw.png",
        article: "/assets/articles/income-limits.md",
        slug: "income-limits"
    }, {
        title: "NYC Community Board Preference & Housing Lottery",
        published: "2024-04-10",
        shortDescription: "Learn what Community Board preferences mean and how they impact your housing lottery application.",
        description: "Learn how NYC community-board preference works and why it can boost your lottery odds, plus a free tool that files every eligible application for you.",
        thumbnail: "https://cdn-images-1.medium.com/max/1600/0*B_eeqDw6Pe_Y5e40.png",
        article: "/assets/articles/community-board.md",
        slug: "community-board"
    }, {
        title: "Am I Eligible for the NYC Housing Lottery?",
        published: "2024-04-19",
        shortDescription: "Wondering if you’re eligible for the NYC Housing Lottery? Check income, documents, and household criteria here.",
        description: "Check NYC Housing Lottery age, income & residency rules, plus a free tool that files every eligible application for you.",
        thumbnail: "https://cdn-images-1.medium.com/max/1600/1*_2GbhvkBbeWrKT4dzAoYuw.png",
        article: "/assets/articles/qualifying.md",
        slug: "qualifying"
    }, {
        title: "Mathias & Inês’ housing lottery story",
        published: "2025-10-12",
        shortDescription: "Mathias and Inês both work full-time, and like many couples in Brooklyn, they loved the city, but the cost of living was always in the background. Rent kept climbing, and the idea of finding something affordable felt unrealistic. Then they found Homey.",
        description: "Mathias and Inês both work full-time, and like many couples in Brooklyn, they loved the city, but the cost of living was always in the background. Rent kept climbing, and the idea of finding something affordable felt unrealistic. Then they found Homey.",
        thumbnail: "/assets/landing-page/reviews/mathias.webp",
        slug: "mathias-ines-story",
    }, {
        title: "Bianca’s housing lottery story",
        published: "2025-11-29",
        shortDescription: "When Bianca first moved to Brooklyn, she loved the city — but rent kept taking more of her paycheck. Even with a good job, the idea of staying long-term felt out of reach. Starting a family here? Almost impossible. That’s when she started using Homey.",
        description: "When Bianca first moved to Brooklyn, she loved the city — but rent kept taking more of her paycheck. Even with a good job, the idea of staying long-term felt out of reach. Starting a family here? Almost impossible. That’s when she started using Homey.",
        thumbnail: "/assets/landing-page/reviews/bianca.webp",
        slug: "bianca-story",
    }];
